import * as React from "react";

import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";

import AgapeIcon from "../../../common/icons/AgapeIcon";

const useStyles = makeStyles((theme) => ({
  priceBtn: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "15px",

    padding: "5px !important",
    fontFamily: "Vazir-bold",
    textAlign: "center",

    height: "30px !important",
    "&:hover": {
      transform: "none",
    },
    "& *": {
      color: theme.palette.landing.light,
    },
  },
  currency: {
    fontSize: "1.181rem !important",
    [theme.breakpoints.down("md")]: {
      fontSize: ".8rem !important",
    },
  },
  donateValue: {
    fontSize: "1.7rem !important",
    fontFamily: "vazir-bold",
    textAlign: "center",
    paddingTop: "5px",
    width: "60%",

    [theme.breakpoints.down("md")]: {
      fontSize: "1.1rem !important",
    },
    color: "#6c757d",
  },
  activeTab: {
    backgroundColor: theme.palette.landing.main,
    "& *": {
      color: "white",
    },
    "&:hover": {
      backgroundColor: theme.palette.landing.main,
    },
  },

  gridClass: {
    maxWidth: "10%",
    margin: "2px",
    padding: "2px",
    [theme.breakpoints.down("md")]: {
      maxWidth: "30.5%",
    },
  },
}));

const SelectSupportValueMobile = ({ activeTab, handleTabChanged }) => {
  const classes = useStyles();

  return (
    <Grid
      item
      container
      xs={12}
      sm={12}
      md={12}
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item xs sm md className={classes.gridClass}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => handleTabChanged(0)}
          className={clsx(
            classes.priceBtn,
            activeTab === 0 && classes.activeTab
          )}
        >
          <AgapeIcon
            icon="logo-euro"
            size="15px"
            color="rgba(21, 52, 42, 0.72)"
          />
          <Typography variant="caption" className={classes.donateValue}>
            5
          </Typography>
        </Button>
      </Grid>
      <Grid item xs sm md className={classes.gridClass}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => handleTabChanged(1)}
          className={clsx(
            classes.priceBtn,
            activeTab === 1 && classes.activeTab
          )}
        >
          <AgapeIcon
            icon="logo-euro"
            size="15px"
            color="rgba(21, 52, 42, 0.72)"
          />
          <Typography variant="caption" className={classes.donateValue}>
            20
          </Typography>
        </Button>
      </Grid>
      <Grid item xs sm md className={classes.gridClass}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => handleTabChanged(2)}
          className={clsx(
            classes.priceBtn,
            activeTab === 2 && classes.activeTab
          )}
        >
          <AgapeIcon
            icon="logo-euro"
            size="15px"
            color="rgba(21, 52, 42, 0.72)"
          />
          <Typography variant="caption" className={classes.donateValue}>
            50
          </Typography>
        </Button>
      </Grid>
      <Grid item xs sm md className={classes.gridClass}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => handleTabChanged(3)}
          className={clsx(
            classes.priceBtn,
            activeTab === 3 && classes.activeTab
          )}
        >
          {" "}
          <AgapeIcon
            icon="logo-euro"
            size="15px"
            color="rgba(21, 52, 42, 0.72)"
          />
          <Typography variant="caption" className={classes.donateValue}>
            100
          </Typography>
        </Button>
      </Grid>
      <Grid item xs sm md className={classes.gridClass}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => handleTabChanged(4)}
          className={clsx(
            classes.priceBtn,
            activeTab === 4 && classes.activeTab
          )}
        >
          {" "}
          <AgapeIcon
            icon="logo-euro"
            size="15px"
            color="rgba(21, 52, 42, 0.72)"
          />
          <Typography variant="caption" className={classes.donateValue}>
            200
          </Typography>
        </Button>
      </Grid>
      <Grid item xs sm md className={classes.gridClass}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => handleTabChanged(5)}
          className={clsx(
            classes.priceBtn,
            activeTab === 5 && classes.activeTab
          )}
        >
          <AgapeIcon
            icon="logo-euro"
            size="15px"
            color="rgba(21, 52, 42, 0.72)"
          />
          <Typography variant="caption" className={classes.donateValue}>
            500
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

export default SelectSupportValueMobile;
